import React, { FC } from 'react';
import Content from './Content';

const BookingView: FC = () => {
    return <Content />;
};

export default BookingView;
